import React, { memo } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { LazyLoadImg } from "../../shared";

const PhotoGridItemStyle = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
`;

import { PHOTO_DETAIL } from "../../../data/links";

const PhotoGridItemRaw = ({ photo, useRouterLink }) => {
    const item = (
        <PhotoGridItemStyle data-testid="photo-item">
            <LazyLoadImg src={photo.assets.thumbnailMedium || ''} alt={photo.title}/>
        </PhotoGridItemStyle>
    );

    return useRouterLink ? (
        <Link to={PHOTO_DETAIL.replace(':photoSlugWithId', photo.slugWithId)}>
            {item}
        </Link>
    ) : (
        <a href={PHOTO_DETAIL.replace(':photoSlugWithId', photo.slugWithId)}>
            {item}
        </a>
    );
};

PhotoGridItemRaw.defaultProps = {
    useRouterLink: true
};

PhotoGridItemRaw.propTypes = {
    photo: PropTypes.shape({
        title: PropTypes.string.isRequired,
        slugWithId: PropTypes.string.isRequired,
        assets: PropTypes.shape({
            thumbnailMedium: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    useRouterLink: PropTypes.bool
};

const PhotoGridItem = memo(PhotoGridItemRaw);

export default PhotoGridItem;
